import jsPDF from "jspdf";
import "jspdf-autotable";

function ComplaintReport(selectedDepartment, dataSource, filteredData) {
  const handleDownloadReport = () => {
    const data = selectedDepartment === "All" ? dataSource : filteredData;

    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Complaint Report", 14, 22);

    const lineY = 28;
    doc.setLineWidth(0.5);
    doc.setDrawColor(192, 192, 192);
    doc.line(14, lineY, 200, lineY);

    const marginTop = 3;
    doc.setFontSize(12);
    doc.text("Employee: All - All employees selected", 14, 32 + marginTop);

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString();
    doc.text(`Report Date: ${formattedDate}`, 14, 42 + marginTop);
    doc.text("Exceptions: No Deletions", 14, 52);
    doc.text(`Department: ${selectedDepartment}`, 14, 59);

    const headers = [
      [
        "Complaint ID",
        "Complaint Title",
        "Complainant Name",
        "Complainant Email",
        "Complainant Phone",
        "Complaint Against",
        "Department",
        "Status",
      ],
    ];

    const dataRows = data.map((complaint) => [
      complaint.key, // maps to your dataSource key
      complaint.ComplaintTitle, // Complaint Type / Title
      complaint.ComplainantName, // Complainant Name
      complaint.ComplainantEmail, // Complainant Email
      complaint.ComplainantPhone, // Complainant Phone
      complaint.ComplaintAgainst, // Complaint Against
      complaint.Department, // Department
      complaint.Status, // Status
    ]);

    doc.autoTable({
      startY: 62,
      head: headers,
      body: dataRows,
      styles: {
        fontSize: 8,
        cellPadding: 2,
        halign: "center",
      },
      headStyles: {
        fillColor: [192, 192, 192],
        fontSize: 8,
        halign: "center",
      },
      alternateRowStyles: { fillColor: [245, 245, 245] }, // optional: striped rows
    });

    doc.save(`complaint_report_${selectedDepartment}.pdf`);
  };

  return { handleDownloadReport };
}

export default ComplaintReport;